import React from 'react';
import { Grid, Typography, Button } from "@material-ui/core";
import '../App.css'
import {  ThemeProvider, withStyles } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../theme';
import globalUseStyles from '../styleHooks';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {FaCheckCircle} from 'react-icons/fa';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);


function SupportFeatured() {
  const globalClasses = globalUseStyles();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
<ThemeProvider theme={theme}>
    <Container className={globalClasses.standardContainer} maxWidth={false} component="section">
        <Grid className={globalClasses.containerSmall} container >
            <Grid className={globalClasses.featuredText} item xs={12} md={12}  >
                <Typography className={globalClasses.typSpacing}  variant="h1">Support</Typography>
                <Typography className={globalClasses.typSpacing}  variant="body1">We use Jira Service Desk to help manage our maintenance work. Service Desk submits your issues to a queue so they can be managed and responded to in a more efficient manner.  We believe this model for managing your maintenance requests will make the process as simple as possible for you and give you the ability to see the status of your requests at all time.</Typography>
                <Typography className={globalClasses.typSpacing}  variant="body1">This process helps bring structure to your work, provides increased visibility into what your team is up to, and helps you get more work done in efforts to deliver better service. </Typography>
                <Typography className={globalClasses.typSpacing}  variant="body1">Clients can submit a question, issue, or new request to our service desk and can expect a response from one of our team members within 24 hours. </Typography>
                <Button className={'primaryButton'} variant="outlined" color="primary" onClick={handleClickOpen}>Submit a Ticket</Button>
            </Grid>
        </Grid>

        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
          <DialogContent className={globalClasses.dialogBoxSuccess}>
            <FaCheckCircle className={globalClasses.iconSuccess}/>
              <Typography gutterBottom>
                We have received your message.  Our service desk will respond to you within 24 hours.
              </Typography>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose} color="primary">Close</Button>
          </DialogActions>
        </Dialog>

    </Container>
</ThemeProvider>
  );
};

export default SupportFeatured;